import { Modal, Row, Col, Typography, Button, Divider } from "antd";
import React from "react";
import {
  MailOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;

const EmailVerificationConfirmation = ({ 
  visible, 
  setVisible, 
  userEmail,
  onConfirm,
  onCancel,
  loading = false,
  setShowAuthenticatorModal,
}) => {
  const handleCancel = () => {
    setVisible(false);
    if (onCancel) {
      onCancel();
    }
    setShowAuthenticatorModal(true);
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
  };

  // Mask email for privacy (show first 2 chars, domain, but hide middle part)
  const maskEmail = (email) => {
    if (!email) return "your registered email";
    const [localPart, domain] = email.split('@');
    if (localPart.length <= 2) return email;
    const maskedLocal = localPart.slice(0, 2) + '*'.repeat(Math.max(localPart.length - 4, 1)) + localPart.slice(-2);
    return `${maskedLocal}@${domain}`;
  };

  return (
    <Modal
      title={null}
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={520}
      closable={false}
      centered
      keyClose={true}
      styles={{
        body: { padding: "32px 24px" }
      }}
    >
      <div>
        <Row gutter={[16, 32]} justify="center">
          <Col span={24}>
            <div style={{ textAlign: "center", marginBottom: "8px" }}>
              <div
                style={{
                  width: "80px",
                  height: "80px",
                  background:
                    "linear-gradient(135deg, #3366ff 0%, #6600ff 100%)",
                  borderRadius: "20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 24px",
                  boxShadow: "0 8px 32px rgba(51, 102, 255, 0.3)",
                }}
              >
                <MailOutlined style={{ fontSize: "36px", color: "white" }} />
              </div>
              <Title
                level={3}
                style={{ 
                  marginBottom: "8px", 
                  color: "#1a1a1a",
                  fontWeight: "600"
                }}
              >
                Email Verification
              </Title>
              <Text
                style={{
                  color: "#666666",
                  fontSize: "15px",
                  lineHeight: "1.5",
                }}
              >
                We'll send a 6-digit verification code to your email
              </Text>
            </div>
          </Col>

          <Col span={24}>
            <div
              style={{
                background: "linear-gradient(135deg, #f8f9ff 0%, #f0f2ff 100%)",
                border: "2px solid #e6f0ff",
                borderRadius: "16px",
                padding: "24px",
                textAlign: "center",
                position: "relative",
                overflow: "hidden",
              }}
            >
              {/* Decorative background element */}
              <div
                style={{
                  position: "absolute",
                  top: "-20px",
                  right: "-20px",
                  width: "60px",
                  height: "60px",
                  background: "rgba(51, 102, 255, 0.1)",
                  borderRadius: "50%",
                  zIndex: 0,
                }}
              />
              
              <div style={{ position: "relative", zIndex: 1 }}>
                <div style={{ marginBottom: "12px" }}>
                  <CheckCircleOutlined 
                    style={{ 
                      color: "#52c41a", 
                      fontSize: "20px",
                      marginRight: "8px" 
                    }} 
                  />
                  <Text
                    style={{
                      color: "#1a1a1a",
                      fontSize: "15px",
                      fontWeight: "500",
                    }}
                  >
                    Verification code will be sent to:
                  </Text>
                </div>
                
                <div
                  style={{
                    backgroundColor: "white",
                    border: "1px solid #d9d9d9",
                    borderRadius: "8px",
                    padding: "12px 16px",
                    margin: "0 auto",
                    maxWidth: "300px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
                  }}
                >
                  <Text
                    strong
                    style={{
                      color: "#3366ff",
                      fontSize: "16px",
                      fontFamily: "monospace",
                    }}
                  >
                    {maskEmail(userEmail)}
                  </Text>
                </div>

                <div style={{ marginTop: "16px", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                  <ClockCircleOutlined style={{ color: "#999999", fontSize: "14px" }} />
                  <Text
                    style={{
                      color: "#666666",
                      fontSize: "13px",
                    }}
                  >
                    Code expires in 10 minutes
                  </Text>
                </div>
              </div>
            </div>
          </Col>

          <Col span={24}>
            <div style={{ textAlign: "center", marginBottom: "16px" }}>
              <Text
                style={{
                  color: "#999999",
                  fontSize: "13px",
                  fontStyle: "italic",
                }}
              >
                Make sure to check your spam folder if you don't see the email
              </Text>
            </div>
          </Col>

          <Col span={24}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "16px",
              }}
            >
              <Button
                size="large"
                onClick={handleCancel}
                style={{
                  minWidth: "140px",
                  height: "48px",
                  borderRadius: "12px",
                  fontWeight: "700",
                  border: "2px solid #d9d9d9",
                }}
              >
                Use Authenticator
              </Button>
              <Button
                type="primary"
                size="large"
                loading={loading}
                onClick={handleConfirm}
                style={{
                  minWidth: "140px",
                  height: "48px",
                  backgroundImage:
                    "linear-gradient(135deg, #3366ff 0%, #6600ff 100%)",
                  border: "none",
                  borderRadius: "12px",
                  fontWeight: "700",
                  boxShadow: "0 4px 16px rgba(51, 102, 255, 0.4)",
                  transform: "translateY(-1px)",
                  transition: "all 0.2s ease",
                }}
              >
                {loading ? "Sending..." : "Send Code"}
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default EmailVerificationConfirmation;